import { Controller, FieldValues } from 'react-hook-form';
import { IReactHookFormAutocompleteProps } from '../..';
import Autocomplete from '../DefaultAutocomplete';

const ReactHookFormAutocomplete = <
  TFieldValues extends FieldValues
>(props: IReactHookFormAutocompleteProps<TFieldValues>) => {
  const {
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
    ...autocompleteProps
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: {
          value, onChange, onBlur, ref,
        },
        fieldState,
      }) => {
        const {
          helperText: preHelperText,
          onChange: autocompleteOnChange,
          ...restAutocompleteProps
        } = autocompleteProps;
        let helperText = preHelperText;
        if (!preHelperText && fieldState.error) {
          const { types, message } = fieldState.error;
          helperText = types ? Object.values(types) : message;
        }
        return (
          <Autocomplete
            {...restAutocompleteProps}
            name={name}
            value={value}
            onChange={(event, newValue, reason, details) => {
              onChange(newValue);
              if (autocompleteOnChange) {
                autocompleteOnChange(event, newValue, reason, details);
              }
            }}
            onBlur={onBlur}
            ref={ref}
            error={!!fieldState.error}
            helperText={helperText}
          />
        );
      }}
    />
  );
};

export default ReactHookFormAutocomplete;
